import { render, staticRenderFns } from "./Municipality.vue?vue&type=template&id=b55331e8"
import script from "./Municipality.vue?vue&type=script&lang=js"
export * from "./Municipality.vue?vue&type=script&lang=js"
import style0 from "./Municipality.vue?vue&type=style&index=0&id=b55331e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports